import { hasCapability, type User } from "../base";

export const certificateOfCompletion = {
  read: (user: User) => hasCapability(user, "certificateOfCompletion.read"),
};
